/* Velvine Bijoux : menu mobile, panier latéral, choix de variante, galerie, tri. */
(function () {
  'use strict';

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Prix en euros, avec la devise du panier */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || '€');
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Menu mobile ---------- */
  var toggle = qs('[data-menu-toggle]');
  var nav = qs('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Recherche : s'ouvre sous l'en-tête ---------- */
  var sToggle = qs('[data-search-toggle]');
  var sPanel = qs('[data-search-panel]');
  if (sToggle && sPanel) {
    var sSet = function (open) {
      sPanel.classList.toggle('is-open', open);
      sToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = qs('[data-search-input]', sPanel); if (i) i.focus(); }
    };
    sToggle.addEventListener('click', function () { sSet(!sPanel.classList.contains('is-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sSet(false); });
    if (/[?&]q=/.test(window.location.search) && window.location.pathname.indexOf('/search') === 0) sSet(true);
  }

  /* ---------- Pied de page : colonnes ouvertes sur ordinateur, repliées sur mobile ---------- */
  if (window.matchMedia && window.matchMedia('(max-width: 860px)').matches) {
    qsa('.footer-col').forEach(function (d) { d.removeAttribute('open'); });
  }

  /* ---------- Recherche avec résultats en direct ---------- */
  var searchBox = qs('[data-search]');
  if (searchBox) {
    var sInput = qs('[data-search-input]', searchBox);
    var sOut = qs('[data-search-results]', searchBox);
    var sCurrency = searchBox.getAttribute('data-currency') || 'EUR';
    var sTimer = null;
    var sLast = '';
    var sHide = function () { sOut.hidden = true; sOut.innerHTML = ''; };
    var sRender = function (products, q) {
      if (!products.length) {
        sOut.innerHTML = '<p class="search-results__empty">Aucun résultat pour « ' + esc(q) + ' ».</p>';
        sOut.hidden = false;
        return;
      }
      var html = '<ul class="search-results__list">' + products.map(function (p) {
        var img = p.image ? '<img src="' + esc(p.image) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="search-results__noimg"></span>';
        var price = p.price ? '<span class="search-results__price">' + money(Math.round(parseFloat(p.price) * 100), sCurrency) + '</span>' : '';
        return '<li><a href="' + esc(p.url) + '">' + img + '<span class="search-results__title">' + esc(p.title) + '</span>' + price + '</a></li>';
      }).join('') + '</ul>' +
        '<a class="search-results__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">Voir tous les résultats</a>';
      sOut.innerHTML = html;
      sOut.hidden = false;
    };
    var sFetch = function (q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== sLast) return;
          sRender((d.resources && d.resources.results && d.resources.results.products) || [], q);
        })
        .catch(sHide);
    };
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      sLast = q;
      clearTimeout(sTimer);
      if (q.length < 2) { sHide(); return; }
      sTimer = setTimeout(function () { sFetch(q); }, 200);
    });
    document.addEventListener('click', function (e) { if (!searchBox.contains(e.target)) sHide(); });
    sInput.addEventListener('keydown', function (e) { if (e.key === 'Escape') sHide(); });
  }

  /* ---------- Panier latéral ---------- */
  var drawer = qs('[data-drawer]');
  var overlay = qs('[data-drawer-overlay]');
  var itemsBox = qs('[data-drawer-items]');
  var foot = qs('[data-drawer-foot]');
  var totalBox = qs('[data-drawer-total]');

  function setCount(n) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    qsa('.cart-link').forEach(function (el) { el.classList.toggle('is-empty', !Number(n)); });
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function syncSuggest(cart) {
    qsa('[data-suggest-item]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      el.hidden = cart.items.some(function (i) { return String(i.product_id) === id; });
    });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    syncSuggest(cart);
    if (!itemsBox) return;
    if (!cart.items.length) {
      itemsBox.innerHTML = '<p class="drawer__empty">Ton panier est vide.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    itemsBox.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_320x320$1$2')) + '" alt="" loading="lazy">' : '<span></span>';
      var first = item.options_with_values && item.options_with_values.length && item.options_with_values[0].value !== 'Default Title' ? item.options_with_values[0].value : '';
      var variant = '<p class="drawer__variant">' + esc(first) + '</p>';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && item.properties[k]) {
            variant += '<p class="drawer__variant">' + esc(k) + ' : ' + esc(item.properties[k]) + '</p>';
          }
        });
      }
      var priceHtml = money(item.final_line_price, cart.currency);
      if (item.original_line_price > item.final_line_price) {
        priceHtml = '<s class="drawer__old">' + money(item.original_line_price, cart.currency) + '</s> ' + priceHtml;
        if (item.discounts && item.discounts.length) {
          variant += '<p class="drawer__variant drawer__disc">' + esc(item.discounts[0].title) + '</p>';
        }
      }
      return '<div class="drawer__item">' + img +
        '<div><a class="drawer__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
        '<div class="drawer__qty"><button type="button" aria-label="Moins" data-qty="' + (i + 1) + ':' + (item.quantity - 1) + '">−</button><span>' + item.quantity + '</span><button type="button" aria-label="Plus" data-qty="' + (i + 1) + ':' + (item.quantity + 1) + '">+</button></div></div>' +
        '<div class="drawer__price">' + priceHtml + '</div></div>';
    }).join('');
    if (cart.item_count === 1 && Date.now() < 1798757999000) {
      itemsBox.innerHTML += '<div class="drawer__nudge"><span class="drawer__nudge-label">Offre de fin d’année</span><span class="drawer__nudge-title">Ajoutez un 2<sup>e</sup> bijou : −15 %</span><span class="drawer__nudge-text">Appliqué automatiquement au panier, jusqu’au 31 décembre.</span></div>';
    }
    var multiNote = document.querySelector('[data-multi-note]');
    if (multiNote) multiNote.hidden = cart.item_count < 2;
    if (totalBox) totalBox.textContent = money(cart.total_price, cart.currency);
    var splitBox = document.querySelector('[data-drawer-split]');
    if (splitBox) splitBox.textContent = (cart.total_price % 4 ? 'environ ' : '') + money(Math.round(cart.total_price / 4), cart.currency);
    if (foot) foot.hidden = false;
  }
  function refreshCart(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openDrawer(); return cart; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-drawer-overlay]')) { closeDrawer(); return; }
    var add = t.closest('[data-suggest-add]');
    if (add) {
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(add.getAttribute('data-suggest-add')), quantity: 1 })
      }).then(function () { return refreshCart(true); })
        .then(function () { add.disabled = false; })
        .catch(function () { add.disabled = false; });
      return;
    }
    var q = t.closest('[data-qty]');
    if (q) {
      var parts = q.getAttribute('data-qty').split(':');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(parts[0], 10), quantity: Math.max(0, parseInt(parts[1], 10)) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Fiche produit : ajout au panier ---------- */
  qsa('[data-product-form]').forEach(function (form) {
    var button = qs('[data-add-to-cart]', form);
    var buyNow = qs('[data-buy-now]', form);
    var errorBox = qs('[data-form-error]', form);

    /* Ajoute la bague au panier, puis ouvre le panier latéral (ou va au paiement) */
    function add(goCheckout) {
      if (button && button.disabled) return;
      if (errorBox) errorBox.hidden = true;
      var saved = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.textContent = 'Ajout…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Impossible d\'ajouter ce produit.');
          if (goCheckout) { window.location.href = '/checkout'; return null; }
          return refreshCart(true);
        })
        .catch(function (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        })
        .then(function () { if (button) { button.disabled = false; button.innerHTML = saved; } });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(false); });
    if (buyNow) buyNow.addEventListener('click', function () { add(true); });
  });

  /* ---------- Carrousels une bague à la fois (téléphone) ---------- */
  qsa('[data-snap]').forEach(function (track) {
    var counter = qs('[data-snap-index]', track.parentElement);
    if (!counter) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var slide = track.firstElementChild;
        if (slide) {
          var step = slide.getBoundingClientRect().width + 12;
          counter.textContent = Math.round(track.scrollLeft / step) + 1;
        }
        ticking = false;
      });
    }, { passive: true });
  });

  /* ---------- Carrousel « Tu aimeras aussi » ---------- */
  qsa('[data-slider]').forEach(function (slider) {
    var wrap = slider.parentElement;
    var step = function (dir) { slider.scrollBy({ left: dir * (slider.clientWidth * 0.8), behavior: 'smooth' }); };
    var prev = qs('[data-slider-prev]', wrap), next = qs('[data-slider-next]', wrap);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  /* ---------- Fiche produit : choix de variante ---------- */
  var section = qs('[data-product-section]');
  if (section) {
    var raw = qs('[data-variants]', section);
    var variants = raw ? JSON.parse(raw.textContent) : [];
    var idInput = qs('[data-variant-id]', section);
    var priceBox = qs('[data-price]', section);
    var addBtn = qs('[data-add-to-cart]', section);

    var update = function () {
      var chosen = {};
      qsa('input[data-option-position]:checked', section).forEach(function (input) {
        chosen[input.getAttribute('data-option-position')] = input.value;
      });
      var match = variants.filter(function (v) {
        return [v.option1, v.option2, v.option3].every(function (val, i) {
          return !chosen[i + 1] || chosen[i + 1] === val;
        });
      })[0];
      var labelEl = qs('[data-btn-label]', section), priceEl = qs('[data-btn-price]', section), buyBtn = qs('[data-buy-now]', section);
      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        if (labelEl) labelEl.textContent = 'Indisponible';
        if (priceEl) priceEl.textContent = '';
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceBox) {
        var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) html += '<s class="price__old">' + money(match.compare_at_price, currency) + '</s>';
        priceBox.innerHTML = html + '<span class="price__now">' + money(match.price, currency) + '</span>';
      }
      var splitEl = qs('[data-split-amount]', section);
      if (splitEl) splitEl.textContent = money(Math.round(match.price / 4), (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR');
      if (addBtn) addBtn.disabled = !match.available;
      if (buyBtn) buyBtn.disabled = !match.available;
      if (labelEl) labelEl.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
      if (priceEl) priceEl.textContent = match.available ? '— ' + money(match.price, (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR') : '';
      if (window.history && history.replaceState) history.replaceState(null, '', '?variant=' + match.id);
    };
    qsa('input[data-option-position]', section).forEach(function (i) { i.addEventListener('change', update); });

    /* Galerie : une photo principale et des vignettes */
    var main = qs('#ProductMainImage', section);
    var track = qs('[data-track]', section);
    var thumbs = qsa('[data-thumb]', section);
    var phone = window.matchMedia ? window.matchMedia('(max-width: 860px)') : { matches: false };
    var setCurrent = function (i) {
      thumbs.forEach(function (b, n) {
        if (n === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      var t = thumbs[i];
      var strip = t && t.closest('.product__thumbs');
      if (strip && phone.matches) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    };
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        if (track && phone.matches) {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        } else if (main) {
          main.removeAttribute('srcset');
          main.src = btn.getAttribute('data-src');
        }
        setCurrent(i);
      });
    });
    /* Ordinateur : les photos se suivent vers le bas, le bloc d'achat reste visible à côté */
    var infoBox = qs('.product__info', section);
    if (infoBox && track && window.matchMedia) {
      var wide = window.matchMedia('(min-width: 861px)');
      var fitInfo = function () {
        infoBox.style.top = wide.matches ? Math.min(96, window.innerHeight - infoBox.offsetHeight - 24) + 'px' : '';
      };
      fitInfo();
      window.addEventListener('resize', fitInfo);
      window.addEventListener('load', fitInfo);
      if (window.ResizeObserver) new ResizeObserver(fitInfo).observe(infoBox);
    }
    /* Téléphone : petite barre sous les photos pour les faire glisser */
    var bar = qs('[data-bar]', section);
    if (bar && track) {
      var barMax = parseFloat(bar.max);
      var syncBar = function () {
        var span = track.scrollWidth - track.clientWidth;
        bar.value = span > 0 ? (track.scrollLeft / span) * barMax : 0;
      };
      track.addEventListener('scroll', syncBar, { passive: true });
      bar.addEventListener('input', function () {
        var span = track.scrollWidth - track.clientWidth;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = (parseFloat(bar.value) / barMax) * span;
      });
      bar.addEventListener('change', function () {
        track.style.scrollSnapType = '';
        track.scrollTo({ left: Math.round(parseFloat(bar.value)) * track.clientWidth, behavior: 'smooth' });
      });
      syncBar();
    }
    /* Sur téléphone : on fait glisser les photos avec le doigt */
    if (track) {
      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          if (track.clientWidth) setCurrent(Math.round(track.scrollLeft / track.clientWidth));
        }, 60);
      }, { passive: true });
    }
  }

  /* ---------- Tri des collections ---------- */
  var sort = qs('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();

/* Largeur réelle de la page (sans la barre de défilement), pour les cartes pleine largeur */
(function () {
  var root = document.documentElement;
  var setW = function () { root.style.setProperty('--vw', root.clientWidth + 'px'); };
  setW();
  window.addEventListener('resize', setW);
  window.addEventListener('load', setW);
})();

/* Fiche produit : le tiroir « Détails, livraison, service client » */
(function () {
  var drawer = document.querySelector('[data-pdrawer]');
  if (!drawer) return;
  var lastBtn = null;
  var open = function (key, btn) {
    lastBtn = btn || null;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('pd-lock');
    drawer.querySelectorAll('details[data-pd]').forEach(function (d) { d.open = d.getAttribute('data-pd') === key; });
    var x = drawer.querySelector('.pdrawer__x');
    if (x) x.focus();
  };
  var close = function () {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('pd-lock');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 320);
    if (lastBtn) lastBtn.focus();
  };
  document.querySelectorAll('[data-pd-open]').forEach(function (b) {
    b.addEventListener('click', function () { open(b.getAttribute('data-pd-open'), b); });
  });
  drawer.querySelectorAll('[data-pd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
})();

/* Grand mot du bas de page : ajusté à la largeur */
(function () {
  var els = document.querySelectorAll('[data-fit-text]');
  if (!els.length) return;
  function fit() {
    els.forEach(function (el) {
      var vertical = getComputedStyle(el).writingMode.indexOf("vertical") === 0;
      var cs = getComputedStyle(el.parentNode);
      var box = vertical
        ? el.closest(".footer-stage").clientHeight + (parseFloat(getComputedStyle(el.closest(".footer-stage")).getPropertyValue("--mark-up")) || 0)
        : el.parentNode.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      el.style.fontSize = "100px";
      var size = vertical ? el.getBoundingClientRect().height : (el.scrollWidth || el.getBoundingClientRect().width);
      if (size) el.style.fontSize = (100 * box / size).toFixed(2) + "px";
    });
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();
